import { render, staticRenderFns } from "./OnlineProfileMetricSettingsDialog.vue?vue&type=template&id=5aba276b&scoped=true"
import script from "./OnlineProfileMetricSettingsDialog.vue?vue&type=script&lang=js"
export * from "./OnlineProfileMetricSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./OnlineProfileMetricSettingsDialog.vue?vue&type=style&index=0&id=5aba276b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba276b",
  null
  
)

export default component.exports